import script from "./insurance-criteria-block.vue?vue&type=script&setup=true&lang=js"
export * from "./insurance-criteria-block.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__